import { render } from "./App.vue?vue&type=template&id=ec9d51fc"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import exportComponent from "C:\\inetpub\\wwwroot\\FinanssivalvontaCMS12\\Finanssivalvonta.web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__